// Copyright (c) 2022, 37.78 Tecnologia Ltda. All rights reserved.

import {
  Avatar,
  Box,
  Chip,
  Grid,
  ListItem,
  ListSubheader,
  Paper,
  styled,
} from "@3778.care/goban";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import LockIcon from "@mui/icons-material/Lock";
import MailIcon from "@mui/icons-material/Mail";
import TransitEnterexitIcon from "@mui/icons-material/TransitEnterexit";
import WorkIcon from "@mui/icons-material/Work";

export const StyledSubHeader = styled(ListSubheader)(
  ({ theme: { spacing } }) => ({
    letterSpacing: spacing(0.1),
  })
);

export const StyledPaper = styled(Paper)(({ theme: { palette } }) => ({
  backgroundColor: palette.grey[50],
}));

export const ItemGrid = styled(Grid)(() => ({
  display: "grid",
  justifyContent: "center",
}));

export const StyledAvatar = styled(Avatar)(({ theme: { spacing } }) => ({
  height: spacing(9),
  marginTop: spacing(4),
  padding: spacing(4),
  width: spacing(9),
}));

export const NameGrid = styled(Grid)(({ theme: { spacing } }) => ({
  display: "grid",
  justifyContent: "center",
  paddingTop: spacing(1),
}));

export const OrganizationGrid = styled(Grid)(({ theme: { spacing } }) => ({
  display: "grid",
  justifyContent: "center",
  paddingTop: spacing(0.5),
}));

export const OrganizationBox = styled(Box)(({ theme: { spacing } }) => ({
  marginRight: spacing(0.5),
}));

export const StyledWorkIcon = styled(WorkIcon)(({ theme: { palette } }) => ({
  color: palette.text.secondary,
}));

export const ProfileGrid = styled(Grid)(({ theme: { spacing } }) => ({
  display: "grid",
  justifyContent: "center",
  paddingBottom: spacing(1.5),
  paddingTop: spacing(3),
}));

export const ProfileChip = styled(Chip)(({ theme: { spacing } }) => ({
  fontSize: 14,
  marginBottom: spacing(2),
}));

export const StyledMailIcon = styled(MailIcon)(({ theme: { palette } }) => ({
  color: palette.text.secondary,
}));

export const StyledHelpIcon = styled(LiveHelpIcon)(
  ({ theme: { palette } }) => ({
    color: palette.text.secondary,
  })
);

export const StyledLockIcon = styled(LockIcon)(({ theme: { palette } }) => ({
  color: palette.text.secondary,
}));

export const StyledTransitIcon = styled(TransitEnterexitIcon)(
  ({ theme: { palette } }) => ({
    color: palette.text.secondary,
  })
);

export const StyledListItem = styled(ListItem)(({ theme: { spacing } }) => ({
  marginTop: spacing(1),
}));
